import React from "react";

function Export() {
  return <div>Export page</div>;
}

export default Export;
